import React from 'react';
import './stylesLarge.scss';
import './stylesSmall.scss';

const HeaderNavigationOverlay = () => <div className="header-navigation-overlay" />;

export default HeaderNavigationOverlay;
